import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const FILTERS = ["all", "residential", "commercial", "interior"];

export default function Portfolio() {
  const { t, i18n } = useTranslation();
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("all");
  const isIT = i18n.language.startsWith("it");

  useEffect(() => {
    api.get("/portfolio").then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  const filtered = filter === "all" ? projects : projects.filter((p) => p.category === filter);
  const cats = t("portfolio.categories", { returnObjects: true });
  const label = (c) => (c === "all" ? t("portfolio.all") : cats[c] || c);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
      <div className="text-center">
        <h1 className="font-serif text-5xl lg:text-6xl text-stone-900" data-testid="portfolio-title">
          {t("portfolio.title")}
        </h1>
        <div className="mt-4 w-16 h-[2px] bg-[#D06D4D] mx-auto" aria-hidden="true" />
        <p className="mt-6 text-lg text-stone-700 max-w-2xl mx-auto">{t("portfolio.sub")}</p>
      </div>

      <div className="mt-12 flex flex-wrap gap-3 justify-center">
        {FILTERS.map((c) => (
          <button
            key={c}
            data-testid={`portfolio-filter-${c}`}
            onClick={() => setFilter(c)}
            className={`px-5 py-2 text-xs uppercase tracking-widest border rounded-full transition-colors ${
              filter === c
                ? "bg-stone-900 text-white border-stone-900"
                : "border-stone-300 text-stone-700 hover:border-stone-900 hover:text-stone-900"
            }`}
          >
            {label(c)}
          </button>
        ))}
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
        {filtered.map((p) => (
          <Link
            key={p.id}
            to={`/portfolio/${p.id}`}
            data-testid={`portfolio-item-${p.id}`}
            className="group block"
          >
            <div className="aspect-[4/5] overflow-hidden bg-stone-100">
              {p.cover_url && <img
                src={p.cover_url}
                alt={isIT ? p.title_it : p.title_en}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />}
            </div>
            <div className="mt-5">
              <h3 className="font-serif text-2xl text-stone-900">{isIT ? p.title_it : p.title_en}</h3>
              <p className="mt-2 text-stone-600 text-sm leading-relaxed">
                {(isIT ? p.description_it : p.description_en)?.slice(0, 140)}{(isIT ? p.description_it : p.description_en)?.length > 140 ? "…" : ""}
              </p>
            </div>
          </Link>
        ))}
        {filtered.length === 0 && (
          <p className="text-stone-500 col-span-full text-center py-10" data-testid="portfolio-empty">Nessun progetto in questa categoria.</p>
        )}
      </div>
    </div>
  );
}
